export function truncate(str, maxLen, alwaysAddEllipsis = false) {
    if (str?.length <= maxLen) {
      return alwaysAddEllipsis ? str + "…" : str;
    }
    return str?.slice(0, maxLen) + "…";
}
